import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  icon: {
    fontSize: '1.25em',
    color: '#000429',
    cursor: 'pointer',
  },
  flex: {
    display: 'flex',
  },
  button: {
    marginLeft: 'auto',
  },
}));
